import axios from "axios"
import apiUrl from "../Config";

export const getallproperties = async (params) => {
    try {
        const response = await axios.get(`${apiUrl}/property/getallproperties`, params ? { params } : undefined);
        // Return the entire response data since it contains both properties and pagination info
        return response.data;
    } catch (error) {
        console.error('Error fetching properties:', error);
        // Return empty array in case of error to prevent undefined errors
        return [];
    }
}

export const ContactUs = async (formData) => {
    try {
        const response = await axios.post(
            `${apiUrl}/contactus/createcontactus`,
            formData
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
};

export const createPropertyEnquiry = async (payload) => {
    try {
        const response = await axios.post(
            `${apiUrl}/propertyenquiry/createpropertyenquiry`, payload,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error(error);

    }
};

export const searchProperties = async (params) => {
    try {
        const response = await axios.get(`${apiUrl}/property/getallproperties`, { params });
        return response.data.properties;
    } catch (error) {
        console.error(error);
    }
}

export const getalllocations = async () => {
    try {
        const response = await axios.get(`${apiUrl}/property/getlocations`);
        return response.data.locations;
    } catch (error) {
        console.error(error);


    }
}

export const getallcities = async () => {
    try {
        const response = await axios.get(`${apiUrl}/property/getpropertycities`);
        return response.data;
    } catch (error) {
        console.error('Failed to fetch cities');
        throw error;
    }
}

export const getPropertyById = async (id) => {
    try {
        const response = await axios.get(`${apiUrl}/property/getproperties/${id}`);
        return response.data;
    } catch (error) {
        console.error('Failed to fetch property by ID:', error);
        throw error;
    }
}
export const getallBlogs = async () => {
    try {
        const response = await axios.get(`${apiUrl}/blog/getallblogs`);
        return response.data.blog;
    } catch (error) {
        console.error('Failed to fetch blogs');
        throw error;
    }
}

